import { SxProps, Theme } from '@mui/material';

export const navBarSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    borderBottom: '1px solid #e0e0e0',
    px: { xs: 2, md: 3 },
    py: 0,
    height: '52px',
    position: 'sticky',
    top: 0,
    zIndex: 100,
};

export const navLogoGroupSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
};

export const navLogoSx: SxProps<Theme> = {
    height: '28px',
    width: 'auto',
    display: 'block',
};

export const navDividerSx: SxProps<Theme> = {
    borderColor: '#e0e0e0',
    my: 1.5,
};

export const navSignOutSx: SxProps<Theme> = {
    fontFamily: 'GraphikRegular, sans-serif',
    fontSize: '13px',
    color: '#002B5A',
    borderColor: '#002B5A',
    textTransform: 'none',
    px: 2,
    py: 0.5,
    '&:hover': {
        backgroundColor: '#002B5A',
        color: '#fff',
        borderColor: '#002B5A',
    },
};
